import React, { useEffect, useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      background: transparent;
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const data = useStaticQuery(graphql`
    query {
      avatar: file(sourceInstanceName: { eq: "images" }, relativePath: { eq: "me.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, traceSVG: { color: "#64ffda" }) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);

  const revealContainer = useRef(null);

  useEffect(() => {
    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Typescript',
    'JavaScript (ES6+)',
    'React',
    'Next/Gatsby',
    'HTML & CSS/Scss',
    'Bootstrap',
    'Tailwind',
    'CMS',
    'Redux',
    'Graphql',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>Greetings! I'm Tahir, a Frontend Software engineer based in Abbottabad, Pakistan.</p>

            <p>
              I enjoy creating things that live on the internet, whether that be websites, Mobile
              applications, or anything in between. My goal is to always build products that provide
              pixel-perfect, performant experiences.
            </p>

            <p>
              My passion for programming started early at age 15 where I started learning the
              concepts of basic programming practically, after a year I got introduced with C/C++
              language where I started learning the basic concepts of writing basic programs but the
              more was learning the more curious I got which took me in the depth of programming and
              started bachelors of computer science, which opened new doors of learning and
              knowledge for me, then I got familiar to Java, concepts of OOP, database and many
              more.
            </p>
            <p>
              The journey was going great but then I found{' '}
              <a href="https://www.linkedin.com/in/zain-arshad-5b762a65/">Zain Arshad</a> as a
              mentor in the year 2018, he showed me the door of JavaScript programming language and
              it was the time when my brain started pushing notifications. Within few days I was
              called by the <a href="https://www.codematics.co/">Codematics Inc.</a> for internship
              and there everything shifted for me. There I met{' '}
              <a href="https://www.linkedin.com/in/nouman-khan-571487116/">Nouman Khan </a> who was
              a programming guru for me and introduced me to the frontend technologies like HTML,
              CSS, JavaScript and React etc.
            </p>

            <p>
              Shortly after graduating from <a href="http://gpgcm.edu.pk/">GPGC</a>, I joined an
              engineering team under the supervision of{' '}
              <a href="https://www.linkedin.com/in/amish-maqbool-khan-34bb68174/">
                Amish Maqbool Khan
              </a>{' '}
              and <a href="https://www.linkedin.com/in/jdr86/">Junaid E. Rajput</a> at{' '}
              <a href="https://www.linkedin.com/company/stellar-stack/mycompany/">Stellar Stack</a>{' '}
              Where we've been using the JAM STACK architecture since day-one and worked on a wide
              variety of interesting and meaningful projects.
            </p>

            <p>Here are a few technologies I've been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <Img fluid={data.avatar.childImageSharp.fluid} alt="Avatar" className="img" />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
